/**
 * «Abrir y cerrar carpetas» en Editar usuario (solo root).
 *
 * `value` son SOLO las marcas propias del usuario (users/{uid}.Carpetas), que
 * valen en todas sus empresas y suman a lo del rol. Lo que el rol ya da se
 * muestra marcado y bloqueado, sin tocar `value`: si después cambia el rol,
 * el usuario conserva solo lo que root le dio. La matriz de cada empresa puede
 * decidir distinto (lib/closed_folder_perms.js).
 */
import React from 'react';
import { Checkbox, Typography } from 'antd';

const OPTIONS = [['abrir', 'Abrir carpetas'], ['cerrar', 'Cerrar carpetas']];

export const CarpetasField = ({ value = [], onChange, roleGives = {} }) => {
  const toggle = (k, checked) => {
    const next = value.filter(v => v !== k);
    onChange?.(checked ? [...next, k] : next);
  };
  return (
    <div>
      {OPTIONS.map(([k, label]) => (
        <div key={k}>
          <Checkbox
            checked={roleGives[k] === true || value.includes(k)}
            disabled={roleGives[k] === true}
            onChange={e => toggle(k, e.target.checked)}
          >
            {label}
          </Checkbox>
          {roleGives[k] === true ?
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>lo da el rol</Typography.Text> : null}
        </div>
      ))}
    </div>
  );
};

export default CarpetasField;
